import React from "react";
import Footer from "components/footer/Footer";
import Header from "components/header/Header";
import UserHeroSection from "components/user/UserHeroSection";
import UserProfile from "components/user/UserProfile";
import UserAuth from "components/AuthGaurd/UserAuth";

export default function MyProfile() {
  return (
    <UserAuth>
      <header>
        <Header />
      </header>
      <UserHeroSection title="My Profile">
        <UserProfile />
      </UserHeroSection>

      <footer className="tw-hidden lg:tw-block">
        <Footer />
      </footer>
    </UserAuth>
  );
}
